<!-- <div class="flex items-center justify-center w-full">
    <div
      class="flex min-h-[150px] w-fit min-w-[280px] items-center justify-between px-6 py-4 rounded-lg shadow-md text-white transition-all mb-4 animate-fade-in"
      [ngClass]="{
        'bg-green-500': toast.type === 'success',
        'bg-red-500': toast.type === 'error',
        'bg-yellow-400 text-black': toast.type === 'warning',
        'bg-blue-500': toast.type === 'info'
      }"
    >
      <fa-icon
        [icon]="getIcon(toast.type)"
        class="mr-4 text-2xl"
        [ngClass]="{
          'text-white': toast.type !== 'warning',
          'text-black': toast.type === 'warning'
        }"
      ></fa-icon>
      <span class="flex-1 text-sm sm:text-base">{{ toast.message | translate }}</span>
  
      <button
        class="ml-4 text-2xl text-white transition-all hover:text-opacity-80"
        (click)="removeToast()"
        aria-label="Close toast notification"
      >
        ×
      </button>
    </div>
  </div>
 -->
<!-- 
  <div class="flex items-center justify-center">
    <div
      class="flex items-center max-w-md p-4 space-x-4 transition-all duration-300 ease-out bg-white shadow-lg rounded-xl animate-slide-in"
      [ngClass]="{
        'border-l-4 border-green-500': toast.type === 'success',
        'border-l-4 border-red-500': toast.type === 'error',
        'border-l-4 border-yellow-500': toast.type === 'warning',
        'border-l-4 border-blue-500': toast.type === 'info'
      }"
    >
      <div class="flex-shrink-0">
        <fa-icon
          [icon]="getIcon(toast.type)"
          class="text-2xl"
          [ngClass]="{
            'text-green-500': toast.type === 'success',
            'text-red-500': toast.type === 'error',
            'text-yellow-500': toast.type === 'warning',
            'text-blue-500': toast.type === 'info'
          }"
        ></fa-icon>
      </div>
  
      <div class="flex-1">
        <p class="text-sm text-gray-800 sm:text-base">{{ toast.message | translate }}</p>
      </div>
  
      <button
        (click)="removeToast()"
        class="text-gray-400 rounded-md hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-200"
        aria-label="Close toast notification"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
  </div> -->



  <div class="flex items-center justify-center px-4 sm:px-0">
    <div
    class="rounded-xl bg-gradient-to-r from-[var(--toast-bg-color-start)] to-[var(--toast-bg-color-end)] shadow-lg p-4  transition-all duration-300 ease-out animate-slide-in"
    [style.--toast-bg-color-start]="getBackgroundColorStart(toast.type)"
    [style.--toast-bg-color-end]="getBackgroundColorEnd(toast.type)"
  >
    <div class="flex items-center justify-between mb-2">
      <span class="text-lg font-semibold text-gray-800">
        {{ getTranslationKey(toast.type) }}
      </span>
      <button
        (click)="removeToast()"
        class="text-gray-500 rounded-md hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-300"
        aria-label="Close toast notification"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <div class="flex items-center py-4 space-x-4">
      <div class="flex-shrink-0">
        <fa-icon
          [icon]="getIcon(toast.type)"
          class="text-3xl"
          [ngClass]="{
            'text-green-600': toast.type === 'success',
            'text-red-600': toast.type === 'error',
            'text-yellow-600': toast.type === 'warning',
            'text-blue-600': toast.type === 'info'
          }"
        ></fa-icon>
      </div>

      <div class="flex-1">
        <p class="text-sm text-gray-900 sm:text-base">{{ toast.message }}</p>
      </div>
    </div>
  </div>
</div>
